module.exports = "<div id=\"chat21-preview-loading-files\">\n    <!-- HEADER -->\n    anteprima immagine -> cancel : send\n    vedi telegram desktop\n</div>     "


//////////////////
// WEBPACK FOOTER
// ./src/app/components/preview-loading-files/preview-loading-files.component.html
// module id = ./src/app/components/preview-loading-files/preview-loading-files.component.html
// module chunks = main